
import { Component, Vue } from 'nuxt-property-decorator'

@Component
export default class HostTitle extends Vue {
  host = this.$getAppFromHost()
  icon = `img_${this.host}.svg`
  text = this.$t(`app.${this.host}`)
}
